import CityPageTemplate from "../city-template/CityPageTemplate";
import { watervilleConfig } from "./data";

export default function WatervillePage() {
  return <CityPageTemplate config={watervilleConfig} />;
}